<template>
  <header :class="getHeaderClass">
    <div class="gap-8px h-44px flex items-center text-[#6F7680]">
      <CacheMenu class="p-3px cursor-pointer rounded bg-[#EDFDF9] leading-none" />
      <MIcon
        class="p-3px cursor-pointer leading-none"
        prefix="menu"
        icon="shouye"
        color="#6F7680"
        :size="18"
        @click="handleGoHome"
      />
      <span class="ant-breadcrumb-separator text-16px">/</span>
      <Breadcrumb />
      <slot name="headerLeft"></slot>
      <DingtalkOutlined
        v-if="helpDocumentUrl"
        class="text-24px text-[#0089ff]"
        title="帮助文档"
        @click="() => openWindow(helpDocumentUrl)"
      />
    </div>
    <div class="gap-8px flex items-center">
      <MButton v-if="showBack" @click="handleBack">{{ t('common.back') }}</MButton>
      <slot name="headerRight"></slot>
    </div>
  </header>
</template>

<script lang="ts" setup>
  import { DingtalkOutlined } from '@ant-design/icons-vue';
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { openWindow } from '@mts-fe/utils';
  import { Breadcrumb, CacheMenu } from '@mts/components/CacheMenu';
  import { useDesign } from '@mts/hooks/web/useDesign';
  import { t } from '@mts/hooks/web/useI18n';
  import { routerBack } from '@mts/render';
  import { getUserStore } from '@/store';

  defineOptions({ name: 'PcHeader' });

  const props = withDefaults(
    defineProps<{
      /** 标题行底部间隔 */
      headerGap?: boolean;
      showBack?: boolean;
      /** 默认返回事件前，false取消执行 */
      beforeBackFn?: () => Promise<void | false>;
    }>(),
    {},
  );

  const { prefixCls } = useDesign('page-header');
  const getHeaderClass = computed(() => {
    return [prefixCls, { 'mb-4px !rounded-4px': props.headerGap }];
  });

  const router = useRouter();

  const helpDocumentUrl = computed(() => router.currentRoute.value.meta?.helpDocumentUrl as string);
  const handleGoHome = () => router.push(getUserStore().getUserInfo.homePath);
  const handleBack = async () => {
    if (props.beforeBackFn) {
      const res = await props.beforeBackFn();
      if (typeof res === 'boolean' && !res) return;
    }

    return routerBack();
  };
</script>

<style lang="less">
  @prefix-cls: ~'@{namespace}-page-header';
  .@{prefix-cls} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    border-radius: 4px 4px 0 0;
    background-color: #fff;
  }
</style>
